import { call, put, select } from 'typed-redux-saga'
import { AnyAction } from 'redux'

import services from '@services'
import { HttpStatus, TResponseType } from '@services/base'
import {
  ConsultaMargemPayload,
  MarginAcceptApiErrorCodes,
  MarginAcceptApiErrorResponse,
  MarginApiResponse,
} from '@store/refinanciamento/marginAcceptResult/types'
import { showError } from '@store/ui/error/actions'
import { setLastServiceResponse } from '@store/session/actions'
import { ApplicationState } from '@store/types'
import { StepRefin } from '@utils/enums'
import { ServiceResponseError } from '@exceptions'

import { marginAcceptRequest, marginAcceptSuccess, marginAcceptError } from '../actions'

const extractApiErrorCode = (error: unknown): string | undefined => {
  const errorData = (error as ServiceResponseError | undefined)?.data as
    | MarginAcceptApiErrorResponse
    | undefined

  return errorData?.errors?.find((item) => Boolean(item?.message))?.message
}

export default function* postMarginAcceptSaga(action: AnyAction) {
  const payload = action.payload as ConsultaMargemPayload
  try {
    const { accessToken } = yield* select((state: ApplicationState) => state.session)

    const acceptResponse: TResponseType<MarginApiResponse> = yield* call(
      services.postContractMarginAcceptService,
      {
        accessToken,
        selectedContracts: payload.selectedContracts,
        convenioName: payload.convenioName,
      },
    )

    if (acceptResponse.status !== HttpStatus.SUCCESS) {
      throw new ServiceResponseError({
        message: 'Ocorreu um erro ao consultar a margem',
        data: acceptResponse.data,
        status: acceptResponse.status,
      })
    } else {
      yield* put(
        setLastServiceResponse({
          code: acceptResponse.data?.code || 'OK',
          serviceName: 'postContractMarginAcceptService',
        }),
      )
      yield* put(marginAcceptSuccess())
      yield* call(payload.callback)
    }
  } catch (error) {
    yield* put(marginAcceptError())

    const errorCode = extractApiErrorCode(error)

    yield* put(
      setLastServiceResponse({
        code: errorCode ?? 'ERROR',
        serviceName: 'postContractMarginAcceptService',
      }),
    )

    if (
      errorCode === MarginAcceptApiErrorCodes.PROCESSAMENTO_VIRADA_COMPETENCIA &&
      payload.errorCallback
    ) {
      yield* call(payload.errorCallback, errorCode)
      return
    }

    yield* put(
      showError({
        title: 'Erro',
        message: 'Ocorreu um erro ao consultar a margem',
        actionTitle: 'Tentar Novamente',
        code: StepRefin.ERRO_CONSULTA_MARGEM,
        actionCallback: () => marginAcceptRequest(payload),
      }),
    )
  }
}
